const ElectionsYears = {
    "1" : "2024",
    "2" : "2021",
    "3" : "2017",
    "4" : "2013",
    "5" : "2009",
    "6" : "2006",
    "7" : "2003"
}

export default ElectionsYears;